import ServicePageLayout from "@/components/ServicePageLayout";
import { CTABand } from "@/components/home/HomeSections";
import { Globe, ShoppingCart, Gauge, LayoutPanelTop, Server, Search } from "lucide-react";
import { IMAGES } from "@/data/content";

export default function WebDevelopment() {
  return (
    <ServicePageLayout
      eyebrow="Web Development"
      title="Websites and web apps that load fast and convert"
      intro="From marketing sites that rank on Google to complex customer portals and headless commerce — we build web platforms that are fast, secure and effortless to maintain."
      image={IMAGES.code}
      imageAlt="TechAxis engineer building a high-performance web application"
      offerings={[
        { icon: Globe, title: "Custom web applications", desc: "Dashboards, portals and SaaS products built on modern frameworks with clean, documented code." },
        { icon: ShoppingCart, title: "E-commerce & headless", desc: "Headless storefronts and payment flows engineered for conversion and sub-second page loads." },
        { icon: LayoutPanelTop, title: "Marketing websites", desc: "SEO-friendly, CMS-driven company sites your marketing team can update without a developer." },
        { icon: Gauge, title: "Performance engineering", desc: "Core Web Vitals audits and optimisation that measurably improve rankings and conversion." },
        { icon: Server, title: "APIs & integrations", desc: "Robust REST and GraphQL APIs connecting your website to CRMs, ERPs and payment providers." },
        { icon: Search, title: "Technical SEO", desc: "Structured data, semantic markup and server-side rendering baked in from the first commit." },
      ]}
      process={[
        { title: "Discovery & architecture", desc: "We map user journeys, content and integrations, then propose a fixed scope with transparent pricing." },
        { title: "Design & build", desc: "Weekly demos as designs turn into production code — you see progress, not promises." },
        { title: "Hardening & launch", desc: "Load testing, security review, SEO checks and a zero-downtime launch runbook." },
        { title: "Run & improve", desc: "Optional care plans with monitoring, updates and a monthly improvement roadmap." },
      ]}
      stack={["React", "Next.js", "TypeScript", "Node.js", "FastAPI", "PostgreSQL", "Tailwind", "AWS", "Vercel", "Docker"]}
    >
      <CTABand />
    </ServicePageLayout>
  );
}
